import { queueAppAlert } from "components/common/AppAlerts";

const getToken = () => localStorage.getItem("token");

const getTenantId = () => localStorage.getItem("tenant_id");
let unauthorizedRedirectInProgress = false;

const buildLoginPathForCurrentArea = (pathname = "") => {
  const normalizedPath = pathname || "";
  const isUserArea = normalizedPath.includes("/user/");
  return isUserArea ? "/auth/login/empleado" : "/auth/login";
};

const handleUnauthorized = (authErrorCode = null) => {
  if (unauthorizedRedirectInProgress || typeof window === "undefined") {
    return;
  }

  unauthorizedRedirectInProgress = true;

  const pathname = window.location.pathname || "";
  const loginPath = buildLoginPathForCurrentArea(pathname);

  if (authErrorCode === "TOKEN_EXPIRED" || getToken()) {
    queueAppAlert("Sesion caducada. Inicia sesion de nuevo.", "warning");
  }

  localStorage.removeItem("token");
  window.location.replace(loginPath);
};

export const withTenantHeader = (headers = {}) => {
  const tenantId = getTenantId();
  if (!tenantId) {
    return headers;
  }

  return {
    ...headers,
    "X-Tenant-ID": tenantId,
  };
};

export const buildAuthHeaders = (headers = {}) => {
  const token = getToken();
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  return withTenantHeader({
    ...headers,
    ...authHeaders,
  });
};

export const request = (url, options = {}) => {
  const { method = "GET", headers = {}, body } = options;
  const requestOptions = {
    method,
    headers: withTenantHeader(headers),
  };

  if (body !== undefined) {
    requestOptions.body = body;
  }

  return fetch(url, requestOptions);
};

export const requestWithAuth = (url, options = {}) => {
  const { headers = {}, ...restOptions } = options;
  return request(url, {
    ...restOptions,
    headers: buildAuthHeaders(headers),
  }).then((response) => {
    if (response.status === 401) {
      const authErrorCode = response.headers.get("X-Auth-Error");
      handleUnauthorized(authErrorCode);
    }
    return response;
  });
};

export const parseJsonSafe = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
};

export const ensureOk = (response, errorMessage = "Error en la peticion") => {
  if (!response.ok) {
    throw new Error(errorMessage);
  }
  return response;
};

export const downloadBlob = async (response, fileName) => {
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
